<template>
  <section class ="service">
      <div class="row">
        <div class="col s12">
          <h5 class="white-text center fixRotation">
            {{ $t("home.servicetitle") }}<br>
          </h5>
          <p class="white-text fixRotation" v-html="$t('home.sevicetext')"></p>

        </div>
      </div>
    </section>
</template>

<style scoped>
.fixRotation{
  transform: skewY(-5deg) !important;
}
    .row{
  padding: 10vw;
  padding-top: 0vh;
  padding-bottom: 10vh;
}

.highlight{
    border-left: 4px solid white;
    padding-left: 10px;
}

</style>
